import { useMemo } from 'react';
import {
	getApplicationForProject,
	type Application,
} from '@jira/platform__application-editions/src/application.tsx';
import {
	getEditionForProject,
	type ApplicationEdition,
} from '@jira/platform__application-editions/src/edition.tsx';
import { toProjectType } from '@jira/platform__project-types/src/project-types.tsx';
import { useProject } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/project/index.tsx';
import { useAppEditions } from '@atlassian/jira-tenant-context-controller/src/components/app-editions/index.tsx';

type ProductAndEditionInfo = {
	currentProduct?: Application;
	currentEdition?: ApplicationEdition;
	jiraEdition?: ApplicationEdition;
};

export const useJiraProductAndEdition = (): ProductAndEditionInfo => {
	const appEditions = useAppEditions();
	const { loading, data: project } = useProject();

	return useMemo(() => {
		if (loading) return {};

		const projectType = toProjectType(project?.type);

		if (!projectType) {
			return {};
		}

		return {
			currentProduct: getApplicationForProject(projectType),
			currentEdition: getEditionForProject(projectType, appEditions),
		};
	}, [appEditions, loading, project?.type]);
};
